<div style="padding: 2rem; text-align: center">
      <h2>🚫 Access denied</h2>
      <p>You don’t have permission to view this content.</p>
</div>